module.exports = __webpack_public_path__ + "assets/img/OverGet_btn.48af7a90.png";